

import React from 'react'
import styles from '../../styles/Home.module.css'

const Home = () => {
  return <div className={styles.homeSection} id="home">
    <div>
      <img src="https://avatars.githubusercontent.com/u/110049484?v=4" className='home-img' alt="profile pic"/>
    </div>
    <div>
      <h2 id="user-detail-name">Charchit Khandelwal</h2>
      <h3>Full Stack Web Developer</h3>
    </div>
  </div>
}

export default Home